import type { NodeDataType } from './GraphType';
import type { Node, NodeProps } from '@xyflow/react';
import { Handle, Position } from '@xyflow/react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { useStore } from '@stores/RootStore';
import { fonts } from '@theme/fontsCustomer';

// Node type with custom data for v12 compatibility
type EndNodeType = Node<NodeDataType, 'end'>;
type Props = NodeProps<EndNodeType>;

export const EndNode = observer(({ isConnectable: isNodeConnectable }: Props) => {
  const { workflowDetailStore } = useStore();
  const isEditable = workflowDetailStore.checkEditable();
  const isConnectable = isNodeConnectable && isEditable;

  return (
    <Container isSelected={false}>
      <Handle
        type="target"
        position={Position.Top}
        id="normal"
        isConnectable={isConnectable}
        style={{
          width: 8,
          height: 8,
          background: '#fff',
          border: '2px solid #9CA3AF',
        }}
      />
      <End>End</End>
    </Container>
  );
});

const Container = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  width: 61px;
  height: 36px;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors['bg-white']};
  border-radius: 20px;
  border: 1px solid ${props => props.theme.colors['border-gray-lighter']};
  transform: translateX(30%);
`;

const End = styled.div`
  color: ${props => props.theme.colors['text-gray-sub-dark']};
  ${fonts.Headline8};
`;
